import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

export const TableCertificationFragmentGql: DocumentNode = gql`
fragment TableCertificationFragment on DatabaseTable {
  isCertified
  certificationNote
  certifier {
    ...TableauUserFragment
  }
}
${TableauUserFragmentGql}
`;
